<template>
  <div class="header-wrapper">
    <!--顶部导航栏-->
    <div id="header">
      <div class="inner">
        <img class="logo" referrerpolicy="no-referrer" src="~@/assets/layout/logo.png" @click="openInNewPage('/nav')" alt=""/>
        <div class="nav" v-if="!showSearchTextBox">
          <div v-for="(nav,index) in navs" :key="index" class="item" :class="menuIndex===index?'current':''" @click.stop="openInNewPage(nav.url)">{{ $t(nav.name) }}</div>
        </div>
        <!--        <div class="search-text-box" v-if="showSearchTextBox">-->
        <!--          <div class="box">-->
        <!--            <i class="close" @click="showSearchTextBox = false"></i>-->
        <!--            <input class="key-word" placeholder="Search Community" v-model="searchKeyWord" @keydown.enter="handleSearchText"></input>-->
        <!--            <i class="button-search" @click="handleSearchText"></i>-->
        <!--          </div>-->
        <!--        </div>-->
        <!--        <div class="tool tool-search-text" @click="showSearchTextBox = true">-->
        <!--          <el-tooltip content="Search" :visible-arrow="false" placement="bottom" popper-class="header-tool-tips">-->
        <!--            <i class="icon"></i>-->
        <!--          </el-tooltip>-->
        <!--        </div>-->
        <!--        <div class="tool tool-search-image">-->
        <!--          <el-upload :headers="headerObj" :before-upload="handleBeforeUpload" list-type="picture" :show-file-list="false" action="">-->
        <!--            <el-tooltip content="Search by image" :visible-arrow="false" placement="bottom" popper-class="header-tool-tips">-->
        <!--              <i class="icon"></i>-->
        <!--            </el-tooltip>-->
        <!--          </el-upload>-->
        <!--        </div>-->
        <!--        <div class="tool tool-search-advanced" @click="showAdvanceSearch()">-->
        <!--          <el-tooltip content="Advanced Search" :visible-arrow="false" placement="bottom" popper-class="header-tool-tips">-->
        <!--            <i class="icon"></i>-->
        <!--          </el-tooltip>-->
        <!--        </div>-->
        <!--        <advance-search :dialogVisible="showSearchAdvancedDialog" @closeDialog="closeAdvanceSearch" @openLink="jumpgoStatic"></advance-search>-->
        <div class="user" @mouseenter="showUserMenu = true" @mouseleave="showUserMenu = false">
          <img class="avatar" referrerpolicy="no-referrer" :src="avatarUrl" alt=""/>
          <div class="user-menu" v-if="showUserMenu">
            <div class="header">
              <div class="menu-icon">
                <div class="icon-wrapper">
                  <img class="icon" referrerpolicy="no-referrer" :src="avatarUrl" alt=""/>
                </div>
              </div>
              <div class="menu-title">
                <div class="username">{{ this.userInfo.info.customerName }}</div>
                <div class="vip">VIP</div>
              </div>
            </div>
            <div class="menu-sep"></div>
            <div class="menu-item" @click="openInNewPage('/favorite?menuType=fabric')">
              <div class="menu-icon">
                <img class="icon" referrerpolicy="no-referrer" src="~@/assets/layout/icon/icon-favorite.png" alt=""/>
              </div>
              <div class="menu-title">{{ $t('My Favorites') }}</div>
            </div>
            <div class="menu-item" @click="openInNewPage('/myDesign')">
              <div class="menu-icon">
                <img class="icon" referrerpolicy="no-referrer" src="~@/assets/layout/icon/icon-design.png" alt=""/>
              </div>
              <div class="menu-title">{{ $t('My Design') }}</div>
            </div>
            <div class="menu-item" @click="openInNewPage('/myOrder')">
              <div class="menu-icon">
                <img class="icon" referrerpolicy="no-referrer" src="~@/assets/layout/icon/icon-design.png" alt=""/>
              </div>
              <div class="menu-title">{{ $t('My Order') }}</div>
            </div>
            <div class="menu-item" @click="openInNewPage('/myGarmentSample')">
              <div class="menu-icon">
                <img class="icon" referrerpolicy="no-referrer" src="~@/assets/layout/icon/icon-design.png" alt=""/>
              </div>
              <div class="menu-title">{{ $t('My Development') }}</div>
            </div>
            <div class="menu-item" @click="openInNewPage('/myFabric')">
              <div class="menu-icon">
                <img class="icon" referrerpolicy="no-referrer" src="~@/assets/layout/icon/icon-design.png" alt=""/>
              </div>
              <div class="menu-title">{{ $t('My Fabric') }}</div>
            </div>
            <div class="menu-item" @click="openInNewPage('/wesAiCreate')">
              <div class="menu-icon">
                <img class="icon" referrerpolicy="no-referrer" src="~@/assets/layout/icon/icon-design.png" alt=""/>
              </div>
              <div class="menu-title">{{ $t('W&S AI') }}</div>
            </div>
            <div class="menu-item" @click="openInNewPage('/VRChanel')">
              <div class="menu-icon">
                <img class="icon" referrerpolicy="no-referrer" src="~@/assets/layout/icon/icon-design.png" alt=""/>
              </div>
              <div class="menu-title">{{ $t('VR Showroom') }}</div>
            </div>
            <div class="menu-item" @click="openInNewPage('/privateChanel')">
              <div class="menu-icon">
                <img class="icon" referrerpolicy="no-referrer" src="~@/assets/layout/icon/icon-module.png" alt=""/>
              </div>
              <div class="menu-title">{{ $t('Private Showroom') }}</div>
            </div>
            <div class="menu-item" @click="openInNewPage('/history')">
              <div class="menu-icon">
                <img class="icon" referrerpolicy="no-referrer" src="~@/assets/layout/icon/icon-history.png" alt=""/>
              </div>
              <div class="menu-title">{{ $t('Browsing History') }}</div>
            </div>
            <div class="menu-item" @click="openInNewPage('/userinfo')">
              <div class="menu-icon">
                <img class="icon" referrerpolicy="no-referrer" src="~@/assets/layout/icon/icon-user.png" alt=""/>
              </div>
              <div class="menu-title">{{ $t('Personal Center') }}</div>
            </div>
            <div class="menu-item" @click="openInNewPage('/setting')">
              <div class="menu-icon">
                <img class="icon" referrerpolicy="no-referrer" src="~@/assets/layout/icon/icon-setting.png" alt=""/>
              </div>
              <div class="menu-title">{{ $t('Security Setting') }}</div>
            </div>
            <div class="menu-item" @click="openInNewPage('/help')">
              <div class="menu-icon">
                <img class="icon" referrerpolicy="no-referrer" src="~@/assets/layout/icon/icon-question.png" alt=""/>
              </div>
              <div class="menu-title">{{ $t('Help') }}</div>
            </div>
            <div class="menu-sep"></div>
            <div class="menu-item" @click="handleLoginOut">
              <div class="menu-icon">
                <img class="icon" referrerpolicy="no-referrer" src="~@/assets/layout/icon/icon-logout.png" alt=""/>
              </div>
              <div class="menu-title">{{ $t('Log Out') }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--面包屑-->
    <div v-if="!onlyShowHeader" id="crumb">
<!--      <span class="item">Fabric</span><span class="sep">&gt;</span>-->
<!--      <template v-if="menuName.parent.name != null"><span class="item">{{ menuName.parent.name }}</span><span class="sep">&gt;</span></template>-->
<!--      <template v-if="menuName.child.name != null"><span class="item">{{ menuName.child.name }}</span><span class="sep">&gt;</span></template>-->
<!--      <template v-if="productData != null"><span class="item">{{ productData.productCode }}</span><span class="sep">&gt;</span></template>-->
    </div>
    <!--标题图-->
    <div v-if="!onlyShowHeader & showHeadline" id="headline">
      <img src="~@/assets/layout/headline/en/headline-fabric.png" alt="">
    </div>
    <!--分割线-->
    <div v-if="!onlyShowHeader & !showBanner" class="divider"></div>
    <!--轮播图-->
    <div v-if="!onlyShowHeader & !showBanner" id="banner">
      <el-carousel indicator-position="none" :interval="5000" arrow="never">
        <el-carousel-item>
          <img src="~@/assets/layout/banner/en/banner-fabric-1.jpg" alt="">
        </el-carousel-item>
        <el-carousel-item>
          <img src="~@/assets/layout/banner/en/banner-fabric-2.jpg" alt="">
        </el-carousel-item>
        <el-carousel-item>
          <img src="~@/assets/layout/banner/en/banner-fabric-3.jpg" alt="">
        </el-carousel-item>
        <el-carousel-item>
          <img src="~@/assets/layout/banner/en/banner-fabric-4.jpg" alt="">
        </el-carousel-item>
        <el-carousel-item>
          <img src="~@/assets/layout/banner/en/banner-fabric-5.jpg" alt="">
        </el-carousel-item>
        <el-carousel-item>
          <img src="~@/assets/layout/banner/en/banner-fabric-6.jpg" alt="">
        </el-carousel-item>
      </el-carousel>
    </div>
  </div>
</template>

<script>

import {getCartList, picSearch, getQuickSearch, getFavoriteSum, getDesignById} from '/api/goods'
import {getMenuName} from '/api/index.js'
import {loginOut, getFrontMenu, getMenuChildren, getFrontDesignMenu, getDesignMenuChildren} from '/api/index'
import {mapMutations, mapState} from 'vuex'
import {setStore, getStore, removeStore} from '/utils/storage'

import advanceSearch from '/components/advanceSearch-backup20230629'
// import menu from "element-ui/packages/menu";
export default {
  name: 'headerlist',
  props: {
    showHeadline:
      {
        type: Boolean,
        default: false
      },
    showBanner:
      {
        type: Boolean,
        default: true
      }
  },
  data () {
    return {
      // onlyShowHeader: true,
      //
      // showMenu: true,
      // showMbx: true,
      // avatarUrl: null,
      // designData: null,
      // designMenu: [],
      // designMenuChildren: [],
      // childId: null,
      // menuChildren: [],
      // infoSel: 0,
      // userInfoSel: false,
      // menuIndex: -1,
      // isSelect: false,
      // favoriteSum: 0,
      // cartSum: 0,
      // id: null,
      // mouseOnId: null,
      // mouseOnChildId: null,
      // showNav: false,
      // showAdSearch: false,
      // searchIpt: '',
      // menuData: [],
      // input: null,
      // headerObj: {},
      // // searchUrl: '',
      // menuName: {
      //   parent: {
      //     id: null,
      //     name: null
      //   },
      //   child: {
      //     id: null,
      //     name: null
      //   }
      // }
      navs: [
        {
          name: 'Fabric',
          url: '/goods?primaryId=163&secondaryId=250'
        },
        {
          name: 'Style Library',
          url: '/designlist?parentId=4&id=125'
        },
        {
          name: 'Public Showroom',
          url: '/commonChanel'
        },
        {
          name: 'Private Showroom',
          url: '/privateChanel'
        }
      ],
      showMbx: true,
      productData: null,
      designData: null,
      avatarUrl: null,
      parentMenuName: null,
      childMenuName: null,
      designMenu: [],
      menuChildren: [],
      infoSel: 0,
      menuIndex: -1,
      showSearchTextBox: false,
      showUserMenu: false,
      showSearchAdvancedDialog: false,
      favoriteSum: 0,
      cartSum: 0,
      primaryCategoryId: null,
      secondaryCategoryId: null,
      mouseOnId: null,
      mouseOnChildId: null,
      onlyShowHeader: false,
      searchIpt: '',
      menuData: [],
      searchKeyWord: null,
      headerObj: {},
      showPublic: false,
      showPrivate: false,
      menuName: {
        parent: {
          id: null,
          name: null
        },
        child: {
          id: null,
          name: null
        }
      }
    }
  },
  created () {
    this.childId = this.$route.query.id
    this.id = this.$route.query.parentId
    if (this.$route.path === '/privateChanel') {
      this.menuIndex = 3
      this.showPrivate = true
    }
    if (this.$route.path === '/commonChanel') {
      this.menuIndex = 2
      this.showPublic = true
    }
    if (this.$route.path === '/chanels') {
      this.onlyShowHeader = true
    }

    // 国际化
    this.$i18n.locale = getStore('language')
    // this.menuName.parent.id = this.id
    // this.menuName.child.id = this.childId
    //
    // if (this.$route.path === '/designlist') {
    //   this.menuIndex = 1
    // }
    // if (this.$route.path === '/welcome') {
    //   this.menuIndex = -1
    // }
    //
    // if (this.$route.path === '/shapeDetails') {
    //   this.showMenu = false
    // }
    //
    // if (this.$route.path === '/styleShow') {
    //   this.onlyShowHeader = true
    //   this.showMbx = false
    // }
    this.avatarUrl = `https://www.ws-showroom.com/image/avatar/` + this.userInfo.info.avatar

    // if (this.id == null) {
    //   this.menuIndex = 0
    // }
    // switch (this.id) {
    //   case '62': this.menuIndex = 1
    //     break
    //   case '69': this.menuIndex = 2
    //     break
    //   case '71': this.menuIndex = 3
    //     break
    //   case '70': this.menuIndex = 4
    //     break
    // }
    this._getDesignMenu()
    this._getDesignMenuChildren()
    this._getDesignById()
    // this._getSelectParentMenuName()
    // this._getSelectChildMenuName()
  },
  mounted () {
    // this.childId = this.$route.query.id
    // this.id = this.$route.query.parentId
    this.token = getStore('token')
    if (this.login) {
      this._getCartList()
    } else {
      this.INIT_BUYCART()
    }
    // this._getMenuName()
    // this._getDesignMenu()

    // if (this.$route.path === '/goods') {
    //   this.showNav = true
    // }
    // this._getDesignMenuChildren()

    setTimeout(() => {
      this.getCartSum()
    }, 500)
    this._getFavoriteSum()
  },
  updated () {
    this.getCartSum()
  },
  watch: {
    // '$route' (to, from) {
    //   // 路由发生变化页面刷新
    //   // this.$router.go(0)
    //   this.childId = this.$route.query.id
    //   this.id = this.$route.query.parentId
    // }
    // $route () {
    //   this.childId = this.$route.query.id
    //   this.id = this.$route.query.parentId
    //   this._getDesignMenuChildren()
    //   this._getDesignMenu()

    //   if (this.childId == null) {
    //     this.jumpgo(`/designlist?parentId=${this.id}&id=${this.menuChildren[0].id}`)
    //   }
    //   // setTimeout(() => {
    //   //   if (this.childId == null) {
    //   //     this.jumpgo(`/goods?parentId=${this.id}&id=${this.menuChildren[0].id}`)
    //   //   }
    //   // }, 200)
    //   if (this.$route.path === '/goods') {
    //     this.showNav = true
    //   }
    //   this.getCartSum()
    //   // 路由发生变化页面刷新
    //   this.$router.go(0)
    // }
  },
  computed: {
    ...mapState([
      'cartList', 'login', 'receiveInCart', 'showCart', 'userInfo'
    ])
  },
  methods: {
    ...mapMutations(['ADD_CART', 'INIT_BUYCART', 'ADD_ANIMATION', 'SHOW_CART', 'REDUCE_CART', 'RECORD_USERINFO', 'EDIT_CART']),
    _getDesignById () {
      let params = {
        id: this.$route.query.designId
      }
      getDesignById(params).then(res => {
        this.designData = res.data
      })
    },
    openInNewPage (url) {
      const routeData = this.$router.resolve({
        path: url
      })
      window.open(routeData.href, '_blank')
    },
    handleClickPrimaryCategory (parentId) {
      this.primaryCategoryId = parentId
      this._jumptoFirstChild()
    },

    handleLoginOut () {
      let params = {
        params: {
          token: this.token
        }
      }
      loginOut(params).then(res => {
        removeStore('buyCart')
        removeStore('commonTools')
        removeStore('token')
        removeStore('userId')
        removeStore('userInfo')
        // this.$router.push({
        //   path: '/refreshgoods'
        // })
        window.location.href = '/#/home'
      })
    },
    handleClickSecondaryCategory (itemId) {
      this.secondaryCategoryId = itemId
      let pId = this.primaryCategoryId
      if (this.mouseOnId != null) {
        pId = this.mouseOnId
      }
      // this.openInSelfPage('/goods?parentId=' + pId + '&id=' + itemId)
      this.openInSelfPage('/designlist?parentId=' + pId + '&id=' + itemId)
    },

    _getMenuChildren () {
      let params = {
        id: this.id
      }
      getMenuChildren(params).then(res => {
        this.menuChildren = res.data
        this._getSelectChildMenuName()
      })
    },
    _getDesignMenu () {
      getFrontDesignMenu().then(res => {
        this.designMenu = res
        this.menuData = res
        this._getSelectParentMenuName()
      })
    },
    _getDesignMenuChildren () {
      let params = {
        id: this.id
      }
      getDesignMenuChildren(params).then(res => {
        this.designMenuChildren = res.data
        this.menuChildren = res.data
        this._getSelectChildMenuName()
      })
    },
    _getSelectParentMenuName () {
      var pitem = this.designMenu.filter((p) => {
        return p.id === parseInt(this.menuName.parent.id)
      })
      this.menuName.parent.name = pitem[0]['alias']
    },
    _getSelectChildMenuName () {
      var pitem = this.menuChildren.filter((p) => {
        return p.id === parseInt(this.menuName.child.id)
      })
      this.menuName.child.name = pitem[0]['alias']
    },
    _jumptoFirstChild () {
      let params = {
        id: this.primaryCategoryId
      }
      getDesignMenuChildren(params).then(res => {
        this.designMenuChildren = res.data
        this.menuChildren = res.data
        let chId = this.menuChildren[0].id
        // eslint-disable-next-line eqeqeq
        if (this.id === 4) {
          chId = 125
        }
        if (this.id === 3) {
          chId = 100
        }

        if (this.id === 6) {
          chId = 155
        }
        if (this.id === 5) {
          chId = 129
        }
        this.childId = chId

        // this.jumpgo2(`/designlist?parentId=${this.id}&id=${chId}`)
        this.openInSelfPage(`/designlist?parentId=${this.id}&id=${chId}`)
      })
    },
    changeUserBtn (index) {
      this.infoSel = index
    },
    _getFavoriteSum () {
      getFavoriteSum({userId: getStore('userId')}).then(res => {
        this.favoriteSum = res.data
      })
    },
    say () {
      this.cartSum += 1
    },
    openInSelfPage (url, type) {
      this.$router.push({
        path: url,
        query: {
          type
        }
      })
    },
    jumpgo2 (url, type) {
      let path = this.$router.history.current.path
      if (path !== url) {
        this.$router.push({
          path: url,
          query: {
            type
          }
        })
      }
    },
    jumpgo (valurl) {
      const routeData = this.$router.resolve({
        path: valurl
      })
      window.open(routeData.href, '_blank')
    },
    childClick (cid) {
      this.$emit('resetPagerOne')
      this.childId = cid
      this.id = this.mouseOnId
      this.jumpgo2('/designlist?parentId=' + this.id + '&id=' + cid)
    },
    getCartSum () {
      let sum = 0
      for (let i = 0; i < this.cartList.length; i++) {
        sum += this.cartList[i].cartProductList.length
      }
      this.cartSum = sum
    },

    _getMenuName () {
      if (this.$route.query.parentId != null) {
        this.menuName.parent.id = this.$route.query.parentId
        const params = {
          id: this.$route.query.parentId
        }
        getMenuName(params).then(res => {
          this.menuName.parent.name = res.data.alias
        })
        if (this.$route.query.id != null) {
          this.menuName.child.id = this.$route.query.id
          const params = {
            id: this.$route.query.id
          }
          getMenuName(params).then(res => {
            this.menuName.child.name = res.data.alias
          })
        } else {
          this.menuName.child.id = null
          this.menuName.child.name = null
        }
      } else {
        this.menuName.child.id = null
        this.menuName.child.name = null
        this.menuName.parent.id = null
        this.menuName.parent.name = null
      }
    },
    querySearchAsync (queryString, cb) {
      this.searchType = ''
      if (this.input === undefined) {
        cb([])
        return
      }
      this.input = this.input.trim()
      if (this.input === '') {
        cb([])
      } else {
        this.loadAll(this.input)
        setTimeout(() => {
          cb(this.searchResults)
        }, 300)
      }
    },
    loadAll (keyinput) {
      let params = {
        params: {
          key: keyinput,
          sType: this.searchType
        }
      }
      getQuickSearch(params).then(res => {
        if (res === null || res === '') {
          return
        }
        // if (res.error) {
        //   this.showError(res.error.reason)
        //   return
        // }
        var array = []
        var maxSize = 10
        if (res.length <= 10) {
          maxSize = res.length
        }
        for (var i = 0; i < maxSize; i++) {
          var obj = {}
          obj.value = res[i]
          array.push(obj)
        }
        if (array.length !== 0) {
          this.searchResults = array
        } else {
          this.searchResults = []
        }
      })
    },
    handleIconClick (ev) {
      if (this.input === '') {
      } else {
        this.$router.push({
          path: '/goodSearch?r=' + Math.random() + '&cid=' + encodeURIComponent(this.input)
        })
      }
    },
    handleBeforeUpload (file) {
      let fileData = new FormData()
      fileData.append('file', file)
      fileData.append('pn', 0)
      fileData.append('rn', 20)
      picSearch(fileData)
        .then((res) => {
          let products = res.data.briefs.map(item => {
            return item.productId
          })
          products = (products.join(','))
          this.$router.push({path: '/goods?r=' + Math.random() + '&products=' + products})
        })
    },
    _getCartList () {
      this.customerName = this.userInfo.info.customerName
      getCartList({userId: getStore('userId')}).then(res => {
        if (res.code === 20007) {
          setStore('buyCart', res.data)
        }
        // 重新初始化一次本地数据
      }).then(this.INIT_BUYCART)
    },
    toUser () {
      this.$router.push({
        name: 'userInfo'
      })
    },
    goto (name) {
      this.$router.push({
        name: name
      })
    },
    parentMenuClick (parentId) {
      this.id = parentId

      this._jumptoFirstChild()
    },
    childMenuMouseEnter (childId) {
      this.mouseOnChildId = childId
      // this._showChild()
    },
    parentMenuMouseEnter (parentId) {
      this.mouseOnId = parentId
      this._showChild()
    },
    parentMenuMouseLeave (parentId) {
      this.mouseOnId = this.id
      this._showChild()
    },
    _showChild () {
      let params = {
        id: this.mouseOnId
      }
      getDesignMenuChildren(params).then(res => {
        this.designMenuChildren = res.data
        this.menuChildren = res.data
        let chId = this.menuChildren[0].id
        // eslint-disable-next-line eqeqeq
        if (this.id === 4) {
          chId = 125
        }
        if (this.id === 3) {
          chId = 100
        }

        if (this.id === 6) {
          chId = 155
        }
        if (this.id === 5) {
          chId = 129
        }
        this.childId = chId

        // this.jumpgo2(`/designlist?parentId=${this.id}&id=${chId}`)
      })
    },
    toNav () {
      this.$router.push({
        path: '/'
      })
    },
    jumpgoStatic (url, type) {
      this.$router.push({
        path: url,
        query: {
          type
        }
      })
    },
    jumpgoSearch (type) {
      this.$router.push({
        path: this.searchUrl,
        query: {
          type
        }
      })
    },
    jumpTo (url) {
      this.$router.push({
        name: url
      })
    },
    _getMenu () {
      getFrontMenu().then(
        res => {
          this.menuData = res
        }
      )
    },
    handleSelect (item) {
      this.input = item.value
    },
    _loginOut () {
      let params = {
        params: {
          token: this.token
        }
      }
      loginOut(params).then(res => {
        removeStore('buyCart')
        removeStore('commonTools')
        removeStore('token')
        removeStore('userId')
        removeStore('userInfo')
        // this.$router.push({
        //   path: '/refreshgoods'
        // })
        window.location.href = '/#/home'
      })
    },
    showAdvanceSearch () {
      this.showAdSearch = true
    },
    closeAdvanceSearch () {
      this.showAdSearch = false
    }
  },
  components: {
    advanceSearch
  }
}

</script>
<style lang="scss">
/* ::v-deep无效，去除scope。修改element-ui控件样式*/
.header-tool-tips.el-tooltip__popper.is-dark {
  background-color: white !important;
  color: #918CFF !important;
  font-size: 14px !important;
}

#banner .el-carousel__container {
  height: 100%;
  width: 100%;
}
</style>

<style scoped lang="scss">
.styleShowNav {
  display: flex;
  justify-content: left;
  align-items: center;
  height: 66px;
  opacity: 1;
  border-radius: 15px;
  background: rgba(255, 255, 255, 1);
}

.styleNavText1 {
  font-size: 14px;
  margin-left: 10px;
  left: 20px;
  top: 120px;
  width: 37px;
  height: 16px;
  opacity: 1;
  /** 文本1 */
  font-weight: 400;
  letter-spacing: 0px;
  line-height: 15.64px;
  color: rgba(145, 140, 255, 1);
  text-align: left;
  vertical-align: top;
}

.styleNavText2 {
  font-size: 14px;
  margin-left: 10px;
  left: 20px;
  top: 120px;
  width: auto;
  height: 16px;
  opacity: 1;
  /** 文本1 */
  font-weight: 400;
  letter-spacing: 0px;
  line-height: 15.64px;
  color: rgba(121, 121, 123, 1);
  text-align: left;
  vertical-align: top;
}

.header-wrapper {
  background-color: #F7F8FA;

  #header {
    width: 100%;
    min-width: 1248px;
    height: 100px;
    background-color: #F3F4FF;

    > .inner {
      width: 100%;
      min-width: 1248px;
      max-width: 1600px;
      height: 100%;
      margin: 0 auto;
      padding: 0 20px;
      display: flex;
      align-items: center;

      img.logo {
        width: 80px;
        cursor: pointer;
      }

      .nav {
        flex: 1;
        display: flex;
        align-items: stretch;
        height: 100px;

        .item {
          display: inline-block;
          margin-left: 80px;
          padding: 0 5px;
          line-height: 100px;
          width: auto;
          border-bottom: 2px solid transparent;
          font-size: 20px;
          color: #79797B;
          font-weight: 500;
          cursor: pointer;

          &.current, &:hover {
            color: #918CFF;
            border-color: #918CFF;
          }
        }
      }

      .search-text-box {
        flex: 1;
        height: 60px;
        overflow: hidden;
        padding: 0 80px;
        display: flex;
        justify-content: center;

        .box {
          position: relative;
          width: 916px;
          background-color: white;
          border-radius: 30px;
          border: 2px solid #8C91FF;

          i.close {
            display: inline-block;
            position: absolute;
            top: 13px;
            left: 20px;
            width: 30px;
            height: 30px;
            background: url("~@/assets/layout/icon/icon-close.png") no-repeat center center;
            background-size: contain;
            cursor: pointer;
          }

          input.key-word {
            display: inline-block;
            position: absolute;
            top: 0;
            left: 70px;
            right: 70px;
            height: 56px;
            font-size: 16px;
            font-weight: 400;
            color: #8C91FF;
            text-align: center;
            line-height: 56px;
          }

          i.button-search {
            display: inline-block;
            position: absolute;
            top: 13px;
            right: 20px;
            width: 30px;
            height: 30px;
            background: url("~@/assets/layout/icon/icon-search-highlight.png") no-repeat center center;
            background-size: contain;
            cursor: pointer;
          }
        }
      }

      .tool {
        width: 40px;
        height: 40px;
        margin-right: 20px;
        text-align: center;
        cursor: pointer;

        i.icon {
          display: inline-block;
          margin-top: 5px;
          width: 30px;
          height: 30px;
          background-position: center center;
          background-repeat: no-repeat;
          background-size: contain;
        }

        &.tool-search-text {
          i.icon {
            background-image: url("~@/assets/layout/icon/icon-search.png");
          }

          &:hover {
            i.icon {
              background-image: url("~@/assets/layout/icon/icon-search-highlight.png");
            }
          }
        }

        &.tool-search-image {
          i.icon {
            background-image: url("~@/assets/layout/icon/icon-search-image.png");
          }

          &:hover {
            i.icon {
              background-image: url("~@/assets/layout/icon/icon-search-image-highlight.png");
            }
          }
        }

        &.tool-search-advanced {
          i.icon {
            background-image: url("~@/assets/layout/icon/icon-search-advanced.png");
          }

          &:hover {
            i.icon {
              background-image: url("~@/assets/layout/icon/icon-search-advanced-highlight.png");
            }
          }
        }
      }

      .user {
        position: relative;
        margin-left: 10px;

        .avatar {
          display: inline-block;
          height: 40px;
          width: 40px;
          margin-bottom: 10px;
          border-radius: 20px;
          cursor: pointer;
        }

        .user-menu {
          position: absolute;
          z-index: 100;
          width: 200px;
          padding: 12px 0;
          border-radius: 6px;
          background-color: white;
          left: -150px;
          top: 50px;

          > .header {
            display: flex;
            height: 44px;
            width: 100%;
            padding: 0 10px 4px 10px;
            cursor: default;

            .menu-icon {
              margin-right: 20px;

              .icon-wrapper {
                height: 32px;
                width: 32px;
                border-radius: 16px;
                border: 2px solid #918CFF;

                img.icon {
                  display: inline-block;
                  width: 28px;
                  height: 28px;
                  border-radius: 14px;
                  border: 2px solid white;
                }
              }
            }

            .menu-title {
              cursor: default;

              .username {
                font-size: 14px;
                color: #000000;
                font-weight: 500;
                line-height: 20px;
              }

              .vip {
                font-size: 12px;
                color: #B7BBFD;
                font-weight: 500;
                line-height: 16px;
              }
            }
          }

          .menu-item {
            display: flex;
            align-items: stretch;
            height: 30px;
            width: 100%;
            padding: 0 10px;
            margin: 2px 0;
            cursor: pointer;

            .menu-icon {
              position: relative;
              display: flex;
              width: 32px;
              overflow: hidden;
              margin-right: 20px;
              text-align: center;
              align-items: center;
              justify-content: center;

              img.icon {
                position: absolute;
                left: 7px;
                display: inline-block;
                width: 18px;
              }
            }

            .menu-title {
              flex: 1;
              height: 30px;
              line-height: 30px;
              font-size: 14px;
              color: #A6A6A6;
              font-weight: 400;
            }

            &:hover {
              background-color: #F3F4FF;

              .menu-icon {
                img.icon {
                  left: -100px;
                  filter: drop-shadow(107px 0px 0 #918CFF);
                }
              }

              .menu-title {
                color: #918CFF;
              }
            }
          }

          .menu-sep {
            box-sizing: content-box;
            width: 180px;
            height: 1px;
            background-clip: content-box;
            background-color: #EDECEB;
            padding: 8px;
          }
        }
      }
    }
  }

  #crumb {
    display: flex;
    width: 100%;
    padding: 55px 0 15px 0;
    font-size: 14px;
    font-weight: 400;
    color: #918CFF;
    justify-content: center;

    .sep {
      padding: 0 15px;
    }
  }

  #headline {
    display: flex;
    justify-content: center;
    padding-top: 15px;
    padding-bottom: 7px;

    img {
      max-width: 1600px;
      max-height: 126px;
    }
  }

  .divider {
    box-sizing: content-box;
    padding-top: 8px;
    height: 1px;
    width: 100%;
    background-clip: content-box;
    background-color: #CCCCCC;
  }

  #banner {
    box-sizing: content-box;
    height: 21.51vw;
    width: 100%;
    padding-top: 7px;
    padding-bottom: 25px;
    min-height: 275px;
    min-width: 1280px;

    .el-carousel {
      height: 100%;
      width: 100%;

      img {
        height: 21.51vw;
        max-width: 100vw;
        min-height: 275px;
        min-width: 1280px;
      }
    }

  }

  #category {
    margin: 0 auto;
    padding-top: 25px;
    padding-bottom: 5px;
    width: 65vw;
    min-width: 1248px;
    overflow: hidden;

    .primary-category {
      //修正元素左右两边margin
      width: calc(100% + 24px);
      margin: 0 -12px;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      border-bottom: 1px solid #918CFF;

      .item {
        display: inline-block;
        flex: 0 0 auto;
        width: 225px;
        height: 50px;
        line-height: 50px;
        margin: 2px 14px 34px;
        background-color: white;
        border-radius: 10px;
        border: 1px solid #918CFF;
        text-align: center;
        font-size: 14px;
        font-weight: 400;
        color: #918CFF;
        cursor: pointer;

        &:hover {
          box-shadow: 0 0 0 2px #E4E5FE;
          font-weight: 700;
        }

        &.current {
          box-shadow: 0 0 0 2px #E4E5FE;
          font-weight: 700;
          background-color: #918CFF;
          border: none;
          color: white;
        }
      }

      .blank-placeholder {
        width: 225px;
        margin: 0 14px;
      }
    }

    .current-category {
      margin: 30px 0;

      .category-name {
        font-size: 18px;
        font-weight: 700;
        color: #B7BBFD;

      }
    }

    .secondary-category {
      width: 100%;
      display: flex;
      flex-wrap: wrap;

      .item {
        display: inline-block;
        flex: 0 0 auto;
        padding: 0 20px;
        height: 30px;
        line-height: 30px;
        margin: 2px 30px 20px 2px;
        background-color: white;
        border-radius: 5px;
        border: 1px solid rgba(183, 187, 253, 0.3);
        text-align: center;
        font-size: 14px;
        font-weight: 400;
        color: #B7BBFD;
        cursor: pointer;

        &:hover {
          border-color: rgba(183, 187, 253, 1);
          box-shadow: 0 0 4px 1px rgba(0, 0, 0, 0.1);
        }

        &.current {
          box-shadow: 0 0 4px 1px rgba(0, 0, 0, 0.1);
          background-color: #B7BBFD;
          border: none;
          color: white;
        }
      }
    }
  }
}

@media screen and (max-width: 1600px) {
  .header-wrapper {
    #headline {
      img {
        max-width: 100%;
      }
    }
  }
}
</style>




// WEBPACK FOOTER //
// headerChanelMenu.vue?8185ce40